// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components-ResetPassword-___style__main___2JMkn","errorInstructions":"src-components-ResetPassword-___style__errorInstructions___1jYXU","instructions":"src-components-ResetPassword-___style__instructions___Vy6Jk","submitButtonContainer":"src-components-ResetPassword-___style__submitButtonContainer___3GToD","pleaseLoginText":"src-components-ResetPassword-___style__pleaseLoginText___3nbn3","loginLink":"src-components-ResetPassword-___style__loginLink___ssdXC","errorText":"src-components-ResetPassword-___style__errorText___2Ebu3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResetPassword/style.css
// module id = 440
// module chunks = 3